import AddressSelect from "./index";

export const AddressSelectWrapper = AddressSelect;

export default AddressSelectWrapper;
